import { getLanguage, getPageHtml, getPageProps } from '../util/PageUtil';
import { wrapper } from '../store/store';
import { setLanguage } from '../store/languageSlice';
import { setHost } from '../store/hostSlice';
import { parseCookies, setCookie } from 'nookies';
import { getClientIp } from '../util/RequestUtil';

function DefaultPage(props) {
  return getPageHtml(props);
}

function isProductionHost(host) {
  return host && !host.includes('getdeveloper.net');
}

export const getServerSideProps = wrapper.getServerSideProps(
  (store) => async (context) => {
    const { req, res, params, locale } = context;

    const host = req?.headers?.host || '';
    store.dispatch(setHost(host));

    const cookies = parseCookies({ req });
    const adminCookie = cookies.adminUser;

    const lang = getLanguage(locale);
    store.dispatch(setLanguage(lang));

    const { clientIp } = getClientIp(req);

    const slug = params?.slug || [];
    const isHome = slug.length === 0;
    const urlPath = '/' + slug.join('/');

    const pageProps = await getPageProps(
      { ...context, params: { ...params, slug, urlPath, isHome } },
      store,
      adminCookie,
      clientIp,
      lang
    );

    const isPreviewRequest =
      'dlrpreview' in (context.query || {}) ||
      (req?.url || '').includes('dlrpreview');

    if (pageProps?.redirect) {
      res.setHeader('Cache-Control', 'no-store');
      return pageProps;
    } else if (isPreviewRequest) {
      res.setHeader('Cache-Control', 'no-store');
    } else {
      res.setHeader(
        'Cache-Control',
        'public, s-maxage=10, stale-while-revalidate=59'
      );
    }
    const hasJpParam = req.url.includes('&jp');

    const data = pageProps?.props?.data;

    if (!data) {
      return { notFound: true };
    }

    const cmsPath =
      data.path_alias || data.path || data?.attributes?.path?.alias;

    if (!isHome && cmsPath && cmsPath === '/') {
      return { notFound: true };
    }

    // An article listing asked for a page past its last one (`?page=20`).
    if (data.listingOutOfRange) {
      return { notFound: true };
    }

    // An article listing asked for a page that is not a page (`?page=abc`,
    // `?page=0`, `?page=-1`). Back to the bare URL, keeping the locale and
    // any other parameters.
    if (data.invalidListingPage) {
      const [path, search = ''] = (context.resolvedUrl || urlPath).split('?');
      const params = new URLSearchParams(search);
      params.delete('page');
      const rest = params.toString();
      const localePrefix =
        locale && locale !== context.defaultLocale ? `/${locale}` : '';

      res.setHeader('Cache-Control', 'no-store');

      return {
        redirect: {
          destination: `${localePrefix}${path}${rest ? `?${rest}` : ''}`,
          statusCode: 301,
        },
      };
    }

    const isCustom404 =
      data.field_error_codes &&
      data.field_error_codes.length > 0 &&
      data.field_error_codes[0].value === '1';

    const shouldRedirectToHome = lang === 'asia' && hasJpParam;

    if (isCustom404) {
      if (shouldRedirectToHome) {
        return {
          redirect: {
            destination: '/',
            permanent: false,
          },
        };
      }

      setCookie(context, 'custom404', JSON.stringify(data), {
        maxAge: 30 * 24 * 60 * 60,
        path: '/',
      });

      return { notFound: true };
    }

    return pageProps;
  }
);

export default DefaultPage;
